module.exports = __webpack_public_path__ + "static/media/satellite.fb32ca2c.svg";